import React from 'react'
import Text from '../components/Text'
import StyledPageContainer from '../styles/PageContainer'

const Container = StyledPageContainer.extend`
  .empty-page-container {
    /* required for flex */
  }
  .empty-message {
    margin-top: auto;
    margin-left: auto;
    margin-right: auto;
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    font-size: 18px;
    text-align: center;
    max-width: 60vw;
  }

  .empty-note {
    width: 225px;
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    font-size: 13px;
    line-height: 1.24em;
    letter-spacing: -0.2px;
    text-align: center;
  }

  .empty-btn-container {
    padding-top: 26px;
  }

  .empty-btn {
    display: block;
    margin: auto;
    width: 113px;
    height: 42px;
    background-color: #ffffff;
    border: solid 1px #d7d7d7;
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    font-size: 12px;
    html[lang=tw] & {
      font-size: 14px;
    }
  }

`

const EmptyPageContainer = (props) =>
  <Container alignCenter={true}>
    <div className="empty-page-container" id='scroll-view'>
      { props.message && <div className="empty-message">{<Text text={props.message} />}</div> }
      { props.note && <div className="empty-note">{<Text text={props.note} />}</div> }
      <div className="empty-btn-container">
        { props.buttons && props.buttons.map((button, index) =>
          <button
            key={`empty-page-container-button-${index}`}
            className="empty-btn"
            onClick={button.onClick}>
              {button.text}
          </button>
        )}
      </div>
    </div>
  </Container>

EmptyPageContainer.defaultProps = {
  text: '',
  buttons: []
}

export default EmptyPageContainer



// WEBPACK FOOTER //
// ./src/components/EmptyPageContainer.js